import React, { useEffect, useState } from 'react'

 function Input ({text,hint,className,onListenner}) {
 const [textValue, setTextValue] = useState(text || '');

 useEffect(()=>{
   onListenner(textValue);
   console.log(textValue);
 },[textValue]);

  return (
    <div className='inp-wrapper'>
      <input className={className} type="text" placeholder={hint} 
      onInput={ (e) => setTextValue( e.currentTarget.value)} 
      value={textValue} />
    </div>
  )

}
export default Input;
